import { AxiosAdapter, AuthAdapter } from '@adapters';
import { MembershipChangeUseCase } from '@core/useCases';
import { useUserStore } from '@stores';

export const useMembershipChange = () => {
  const axiosAdapter = new AxiosAdapter();
  const authAdapter = new AuthAdapter(axiosAdapter);
  const membershipChangeUseCase = new MembershipChangeUseCase(authAdapter);
  const userStore = useUserStore();
  const changeMembership = async (membershipId: string) => {
    const payload = {
      idHpNo: userStore.userId || '',
      membershipId: membershipId,
    };
    await membershipChangeUseCase.execute(payload);
  };
  return {
    changeMembership,
  };
};
